module.exports = __webpack_public_path__ + "static/media/acacia mall shot 02.43a8ca92.webp";